import { useForm } from "react-hook-form";

import { SelectControllerVertical } from "@components";

import { useLanguage } from "@hooks/useLanguage";

import { BASE_DATA } from "@constants/base-data";
import { useBaseData } from "@hooks/useBaseData";
import { getConvertedMetaData } from "@helpers/inventory/metaDataConvert";

import {
  getConvertedOfficeAddress,
  getConvertedUnitData,
} from "@helpers/baseDataConvert";
import { useQueries } from "@hooks/useQueries";

const { WINGS, OFFICE, DESIGNATIONS } = BASE_DATA;

export const TableFilter = ({ handleQuery }: { handleQuery: any }) => {
  const { language } = useLanguage();
  const { handleQuery: setQueryParam } = useQueries();

  const { data: wings } = useBaseData(WINGS);
  const { data: office } = useBaseData(OFFICE);
  const { data: positions } = useBaseData(DESIGNATIONS);
  const { register, control, setValue, watch } = useForm();

  const watchUnitId = watch("unitId");
  const watchAddressId = watch("addressId");

  return (
    <div className="bg-light rounded p-10 my-10">
      <div className="row pb-0 mb-0">
        <SelectControllerVertical
          control={control}
          label="REPORTS.MANPOWER_REPORTS.DESIGNATION"
          name="designation"
          options={getConvertedMetaData(positions, language)}
          register={register}
          setValue={setValue}
          isSearchable
          selectAction={(e) => {
            // handleParams(e as number);
            handleQuery("positionId", e?.toString() as string);
            setQueryParam("positionId", e?.toString() as string);
          }}
          cols={4}
          portal
        />
        <SelectControllerVertical
          label="REPORTS.MANPOWER_REPORTS.FILTERS.WINGS"
          name="unitId"
          register={{ ...register("unitId") }}
          options={getConvertedUnitData(wings, language) || []}
          setValue={setValue}
          selectAction={(e) => {
            handleQuery("unitId", e);
            setQueryParam("unitId", e.toString());
          }}
          control={control}
          cols={4}
          disabled={watchAddressId}
          isSearchable
          portal
        />
        <SelectControllerVertical
          label="REPORTS.MANPOWER_REPORTS.FILTERS.OFFICE"
          name="addressId"
          register={{ ...register("addressId") }}
          options={getConvertedOfficeAddress(office, language) || []}
          setValue={setValue}
          selectAction={(e) => {
            handleQuery("addressId", e);
            setQueryParam("addressId", e.toString());
          }}
          control={control}
          cols={4}
          disabled={watchUnitId}
          isSearchable
          portal
        />
      </div>
    </div>
  );
};
